import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride'
import { Box, Typography } from '@material-ui/core'
import Tooltip from './Tooltip'
import ClioGif from '../../assets/images/ClioIntegrationHelp.gif'

const steps: Array<any> = [
  {
    target: 'body',
    placement: 'center',
    hideCloseButton: true,
    title: 'Clio Integration',
    content:
      'In this tour, you will be shown where to connect your Clio account to the CORVUM platform.'
  },
  {
    target: '#sidebar-item-Settings',
    placement: 'auto',
    hideCloseButton: true,
    title: 'Settings',
    content:
      'In the settings tab you can customize your account, manage your numbers, record your voicemail greeting, as well as connect to Clio.'
  },
  {
    target: '#integrations-tab',
    placement: 'auto',
    hideCloseButton: true,
    title: 'Integrations',
    content:
      'The integrations tab is where you will connect your Clio account to Corvum.'
  },
  {
    target: '#connect-clio-button',
    placement: 'auto',
    hideCloseButton: true,
    title: 'Connect to Clio',
    content: (
      <Box>
        <Typography sx={{ pb: 2 }}>
          Follow the guidelines on the pop-up to select the correct application
          you use with Clio. You will then be redirected to Clio to Allow Access
          to your Clio Manage application.
        </Typography>
        <Box width="100%">
          <img src={ClioGif} alt="Clio Integration Steps GIF" width="100%" />
        </Box>
      </Box>
    )
  }
]

const ClioIntegrationTour = ({ run, setRun }) => {
  const navigate = useNavigate()

  const [step, setStep] = useState(0)

  const handleJoyrideCallBack = async (data) => {
    const { action, index, status, type } = data

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStep(0)
      setRun('clio', false)

      return
    }

    if (EVENTS.TARGET_NOT_FOUND === type) {
      setStep(index - 1)
      setRun('clio', true)

      return
    }

    if (EVENTS.STEP_AFTER === type) {
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1)

      if (
        action === ACTIONS.NEXT &&
        index === 1 &&
        type === EVENTS.STEP_AFTER
      ) {
        navigate('/dashboard/settings/integrations', { replace: true })
        setTimeout(() => {
          setStep(2)
          setRun('clio', true)
        }, 1000)

        return
      }

      if (
        action === ACTIONS.NEXT &&
        index === 2 &&
        type === EVENTS.STEP_AFTER
      ) {
        setTimeout(() => {
          setStep(3)
          setRun('clio', true)
        }, 1000)

        return
      }

      setStep(stepIndex)
    }
  }

  return (
    <Joyride
      steps={steps}
      stepIndex={step}
      run={run}
      continuous
      showProgress
      showSkipButton
      disableCloseOnEsc
      disableOverlayClose
      callback={handleJoyrideCallBack}
      tooltipComponent={Tooltip}
      styles={{
        tooltipContainer: { display: 'flex', justifyContent: 'center' },
        options: {
          zIndex: 4000
        }
      }}
    />
  )
}

export default ClioIntegrationTour
